jQuery(function($) {
  const scrollAdjust = '#header .header-frame' // スムーズスクロールの補正要素
  // const scrollAdjust = 0  //スムーズスクロールの補正要素
  $('a[href*="#"]')
    .not('.no-move , [target="_blank"]')
    .on('click', function() {
      // アンカーをクリックしたらスクロール
      let href = $(this)
        .attr('href')
        .replace(/.*#/gi, '#') // 同一ページならハッシュ以外を削ってページ遷移を抑止
      autoScroll(href, scrollAdjust)
    })

  if (location.hash) autoScroll(location.hash, scrollAdjust, false) // アクセス時にハッシュがある場合はスクロール
  /**
   * 指定されたセレクタに向かってスクロールを行う
   *
   * @function autoScroll
   * @param  {String} point  移動先のセレクタ
   * @param  {String|Number} adjust 追従ヘッダーの高さを加算し、移動先にヘッダーがかぶらないようにする。ヘッダーのセレクタもしくは数値を入れる
   * @param  {Boolean} [anime=true]  アニメーションの有無
   * @return {Boolean} false
   */

  function autoScroll(point, adjust, anime) {
    if (adjust === undefined) {
      // 未定義なら0
      adjust = 0
    } else if (isNaN(adjust)) {
      // 数値以外でなら要素として高さ取得
      adjust = $(adjust).outerHeight()
    }
    let target = $(point === '#' || point === '' ? 'html' : point)
    if ($(target)[0]) {
      // ターゲットを検出したら実行
      if (anime === true || anime === undefined) {
        // 未定義ならアニメーションさせる
        $('html , body')
          .not(':animated')
          .animate({ scrollTop: target.offset().top - adjust }, 500, 'swing')
      } else {
        $('html , body')
          .not(':animated')
          .animate({ scrollTop: target.offset().top - adjust }, 10, 'linear')
      }
    }
    return false
  }
})
/**
 * このファイルを編集したら main.min.js を再生成すること（webpackビルド環境は無いためterserで手動生成）
 * cat js/_smoothScroll.js > /tmp/_combined.js && grep -v -e "^import " -e "^/\* global" js/main.js >> /tmp/_combined.js
 * npx terser /tmp/_combined.js --compress --mangle --comments false --source-map "url='main.min.js.map',includeSources,filename='main.min.js'" -o js/main.min.js
 */



jQuery(function($) {
  let accBtn = 'sp-menu' // このIDを基準としたアコーディオン
  $('#' + accBtn + '-open,#' + accBtn + '-close').on('click', function() {
    $('#' + accBtn + ',#' + accBtn + '-open,#' + accBtn + '-close').toggleClass(
      'active'
    )
    $('body').toggleClass('lock')
  })

  lozad('.lozad,.chain', {
    rootMargin: '5%',
    loaded: function(el) {
      el.classList.add('active') // 画面に交差した要素をactive
    }
  }).observe()

  // Slick本体はaccessページ等でのみ読み込まれるため、対象要素がある時だけ初期化する(footer.php参照)
  if ($('.js-slick-access').length) {
    $('.js-slick-access').slick({
      accessibility: true,
      autoplay: true,
      autoplaySpeed: 6000,
      speed: 600,
      pauseOnHover: true,
      pauseOnDotsHover: true,
      cssEase: 'ease',
      dots: true,
      dotsClass: 'js-slick-dot',
      draggable: true,
      fade: false,
      arrows: true,
      infinite: true,
      initialSlide: 0,
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: true,
      vertical: false,
      centerMode: true,
      centerPadding: '10.3%'
    })
  }

  function trunk8() {
    $('.js-t8.line3').trunk8({
      // 指定要素に行数制限をかける
      lines: 3,
      fill: '...'
    })
    $('.js-t8.line2').trunk8({
      // 指定要素に行数制限をかける
      lines: 2,
      fill: '...'
    })
    $('.js-t8.line1').trunk8({
      // 指定要素に行数制限をかける
      lines: 1,
      fill: '...'
    })
  }
  trunk8()
  $(window).on('load resize ', function() {
    trunk8()
  })

  $('#js-movie-category-select').change(function() {
    var slug = $(this).val()
    if (slug === '0') {
      window.location.href = hUrl + 'movie/'
    } else if (slug) {
      window.location.href = hUrl + 'movie/movie-category/' + slug + '/'
    }
    return false
  })
  if (typeof movieCategorySlug !== 'undefined' && movieCategorySlug) {
    $('#js-movie-category-select').val(movieCategorySlug)
  }

  $('#js-category-select').change(function() {
    var slug = $(this).val()
    var type = $(this)
      .find('option:selected')
      .attr('class')
    if (type === 'category') {
      window.location.href = hUrl + 'case/category/' + slug + '/'
    } else if (type === 'tag') {
      window.location.href = hUrl + 'case/tag/' + slug + '/'
    }
    return false
  })
  if (typeof categorySlug !== 'undefined' && categorySlug) {
    $('#js-category-select').val(categorySlug)
  }

  // iPhoneでselect要素が長すぎて省略されてしまうのを防ぐ
  $('select').append('<optgroup label="" class="pc-hide sp-hide"></optgroup>')
})
